// @flow strict

import * as React from 'react'

import MonzoLogo from './MonzoLogo'
import TwitterBird from './TwitterBird'
import Facebook from './Facebook'
import styles from './Icons.module.scss'

const Icons = () => {
  return (
    <svg className={styles.icons}>
      <defs>
        <MonzoLogo />
        <TwitterBird />
        <Facebook />
      </defs>
    </svg>
  )
}

export default Icons
